import React, { FC } from 'react';
import { ImageProxyContextsKey, imageProxyURL } from 'lib/util/imgproxy';
import classNames from 'classnames';

interface MealImageProps {
  className?: string;
  url: string | undefined;
  context?: ImageProxyContextsKey;
  title?: string;
}

export const MealImage: FC<MealImageProps> = ({
  className,
  url,
  title = 'meal',
  context = ImageProxyContextsKey.mealThumb
}) => {
  return (
    <img
      className={classNames(className, { 'm-4': !url })}
      src={!url ? '/images/no-meal-photo.svg' : imageProxyURL(url, { context })}
      alt={!url ? 'A dish so delicious, our photographer ate it. (photo coming soon)' : `Plated ${title}`}
    />
  );
};
